import { get_token, get_user_details } from "@/router";
import Swal from "sweetalert2";

export default {
  props: {
    event_id: {
      type: [Number, String],
      default: null,
    },
    event: {
      type: Object,
      default: null,
    },
    inline: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return ({
      current_event_id: null,
      current_event: null,
      selected_event_agenda: null,
      selected_event_speaker: null,
      existing_speakers: [],
      speakers: [],
      speakers_errors: {},
      editPhotoPreviewUrl: null,
      editPhotoFile: null,
      social_platforms: [],
      token_exists: false,
      user_details: {},
      preview_document_url: "",
    });
  },
  mounted() {
    this.token_exists = !!get_token();
    this.user_details = get_user_details();
    this.fetch_social_types();
  },
  watch: {
    event: {
      immediate: true,
      deep: false,
      handler(next) {
        if (!this.inline) return;
        if (!next || typeof next !== "object") return;
        this.init_inline(next);
      },
    },
    event_id: {
      immediate: true,
      handler(next) {
        if (!this.inline) return;
        if (!next) return;
        this.current_event_id = next;
      },
    },
  },
  methods: {
    getToken() {
      return get_token();
    },
    get_user_id() {
      return localStorage.getItem("user_id") || "";
    },
    init_inline(event) {
      this.current_event = event || null;
      this.current_event_id = event?.id ?? this.event_id ?? this.current_event_id;
      const existing = Array.isArray(event?.speakers) ? event.speakers : [];
      this.speakers_errors = {};
      this.speakers = existing.length ? existing.map((s) => this.map_existing_to_form(s)) : [this.new_speaker()];
    },
    open_add_speakers(event) {
      this.current_event = event || null;
      this.current_event_id = event?.id ?? this.event_id ?? null;
      this.existing_speakers = Array.isArray(event?.speakers) ? event.speakers : [];
      this.clear_form();
      this.add_speaker_button();
      if (!this.inline) {
        $("#add_speakers_modal").modal("show");
      }
    },
    open_view_speakers(event) {
      this.selected_event_agenda = event || null;
      $("#event_speakers_modal").modal("show");
    },
    new_speaker: () => ({
      first_name: "",
      last_name: "",
      short_bio: "",
      id: null,
      _original: null,
      _is_existing: false,
      photo: null,
      photoPreviewUrl: "",
      social_links: []
    }),
    map_existing_to_form(speaker) {
      const first_name = speaker?.first_name || "";
      const last_name = speaker?.last_name || "";
      const short_bio = speaker?.bio || speaker?.short_bio || "";
      const photoPreviewUrl = speaker?.speaker_files?.[0]?.file?.file_url || "";
      const social_links = Array.isArray(speaker?.social_urls)
        ? speaker.social_urls.map((l) => ({ platform: l?.social_type?.name || "linkedin", url: l?.social_url || "" }))
        : [];
      const base = {
        ...this.new_speaker(),
        id: speaker?.id ?? null,
        first_name,
        last_name,
        short_bio,
        photo: null,
        photoPreviewUrl,
        social_links,
        _is_existing: true,
      };
      base._original = JSON.stringify({
        first_name: base.first_name,
        last_name: base.last_name,
        short_bio: base.short_bio,
        social_links: base.social_links,
      });
      return base;
    },
    speaker_has_changes(speaker) {
      if (!speaker?._is_existing) return true;
      const now = JSON.stringify({
        first_name: speaker.first_name || "",
        last_name: speaker.last_name || "",
        short_bio: speaker.short_bio || "",
        social_links: speaker.social_links || [],
      });
      return now !== speaker._original || (speaker.photo instanceof File);
    },
    update_speaker_record(speaker) {
      return new Promise((resolve, reject) => {
        const formData = new FormData();
        formData.append("speaker_id", speaker.id);
        formData.append("first_name", speaker.first_name);
        formData.append("last_name", speaker.last_name);
        formData.append("bio", speaker.short_bio || "");
        const social_urls = (speaker.social_links || []).map((link) => ({
          social_type: link.platform,
          social_url: link.url,
        }));
        formData.append("social_urls", JSON.stringify(social_urls));
        if (speaker.photo instanceof File) {
          formData.append("speaker_file", speaker.photo);
        }
        $.ajax({
          type: "POST",
          url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/update_event_speaker/`,
          data: formData,
          processData: false,
          contentType: false,
          headers: { Authorization: `Token ${this.getToken()}` },
          success: (response) => {
            if (response?.status === "success") resolve(response.data);
            else reject(new Error(response?.message || "Failed to update speaker"));
          },
          error: (xhr) => reject(xhr),
        });
      });
    },
    add_speaker_button() {
      this.speakers.push(this.new_speaker());
    },
    remove_speaker(index) {
      this.speakers.splice(index, 1);
    },
    add_social_link(index) {
      if (!Number.isInteger(index)) return;
      if (index < 0 || index >= this.speakers.length) return;
      const speaker = this.speakers.at(index);
      if (!speaker || !Array.isArray(speaker.social_links)) return;
      speaker.social_links.push({ platform: "linkedin", url: "" });
    },
    remove_social_link(speakerIndex, linkIndex) {
      if (!Number.isInteger(speakerIndex) || !Number.isInteger(linkIndex)) return;
      const speaker = this.speakers.at(speakerIndex);
      if (!speaker?.social_links?.length) return;
      if (linkIndex < 0 || linkIndex >= speaker.social_links.length) return;
      speaker.social_links.splice(linkIndex, 1);
    },
    handle_photo_upload(event, index) {
      if (!Number.isInteger(index) || index < 0 || index >= this.speakers.length) return;
      const speaker = this.speakers.at(index);
      if (!speaker) return;
      const file = event?.target?.files?.[0];
      if (!(file instanceof File)) return;
      speaker.photo = file;
      speaker.photoPreviewUrl = URL.createObjectURL(file);
    },
    validate_speakers() {
      this.speakers_errors = {};
      let isValid = true;
      this.speakers.forEach((speaker, index) => {
        if (!speaker.first_name || speaker.first_name.trim() === "") {
          this.speakers_errors["speaker_first_name" + index] = "First name is required.";
          isValid = false;
        }
        if (!speaker.last_name || speaker.last_name.trim() === "") {
          this.speakers_errors["speaker_last_name" + index] = "Last name is required.";
          isValid = false;
        }
      });
      return isValid;
    },
    clear_form() {
      this.speakers = [];
      this.speakers_errors = {};
    },
    async save_speakers() {
      if (!this.validate_speakers()) return;

      if (this.inline) {
        Swal.fire({
          title: "Submitting...",
          text: "Please wait while we process your request.",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        try {
          const existingToUpdate = this.speakers.filter((s) => s?._is_existing && s?.id && this.speaker_has_changes(s));
          const newToCreate = this.speakers.filter((s) => !s?._is_existing);

          for (const s of existingToUpdate) {
            // eslint-disable-next-line no-await-in-loop
            const updated = await this.update_speaker_record(s);
            const idx = this.speakers.findIndex((x) => x === s);
            if (idx !== -1) this.speakers.splice(idx, 1, this.map_existing_to_form(updated));
          }

          if (newToCreate.length) {
            const created = await new Promise((resolve, reject) => {
              const formData = new FormData();
              formData.append("event_id", this.current_event_id ?? this.event_id);
              const payload = newToCreate.map((speaker) => ({
                first_name: speaker.first_name,
                last_name: speaker.last_name,
                bio: speaker.short_bio,
                social_urls: (speaker.social_links || []).map((link) => ({
                  social_type: link.platform,
                  social_url: link.url
                })),
              }));
              formData.append("speakers", JSON.stringify(payload));
              newToCreate.forEach((speaker) => {
                formData.append(
                  "speakers_files",
                  speaker.photo && speaker.photo.constructor?.name === "File"
                    ? speaker.photo
                    : new File([], "empty.txt", { type: "text/plain" })
                );
              });
              $.ajax({
                type: "POST",
                url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/add_event_speaker/`,
                data: formData,
                processData: false,
                contentType: false,
                headers: { Authorization: `Token ${this.getToken()}` },
                success: (response) => {
                  if (response?.status === "success") resolve(response.data);
                  else reject(new Error(response?.message || "Failed to add speakers"));
                },
                error: (xhr) => reject(xhr),
              });
            });

            if (Array.isArray(this.current_event?.speakers)) {
              this.current_event.speakers.push(...created);
            }

            this.speakers = [
              ...this.speakers.filter((s) => s?._is_existing),
              ...created.map((s) => this.map_existing_to_form(s)),
              this.new_speaker(),
            ];
          }

          Swal.fire({
            icon: "success",
            title: "Saved",
            text: "Speakers saved successfully.",
            showConfirmButton: false,
            timer: 2000,
            position: 'bottom-end',
            toast: true
          });
        } catch (e) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: e?.message || "An error occurred while saving speakers.",
            showConfirmButton: false,
            timer: 3000,
            position: 'bottom-end',
            toast: true
          });
        }
        return;
      }
      Swal.fire({
        title: "Submitting...",
        text: "Please wait while we process your request.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
      const formData = new FormData();
      formData.append("event_id", this.current_event_id ?? this.event_id);
      const speakers = this.speakers.map((speaker) => ({
        first_name: speaker.first_name,
        last_name: speaker.last_name,
        bio: speaker.short_bio,
        social_urls: speaker.social_links.map((link) => ({
          social_type: link.platform,
          social_url: link.url
        })),
      }));
      formData.append("speakers", JSON.stringify(speakers));
      this.speakers.forEach((speaker) => {
        formData.append(
          "speakers_files",
          speaker.photo && speaker.photo.constructor?.name === "File"
            ? speaker.photo
            : new File([], "empty.txt", { type: "text/plain" })
        );
      });
      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/add_event_speaker/`,
        data: formData,
        processData: false,
        contentType: false,
        headers: { Authorization: `Token ${this.getToken()}` },
        success: (response) => {
          if (response.status === "success") {
            Swal.fire({
              icon: "success",
              title: "Speakers Added",
              text: response.message,
              showConfirmButton: false,
              timer: 2000,
              position: 'bottom-end',
              toast: true
            }).then(() => {
              if (this.current_event?.speakers) {
                this.current_event.speakers.push(...response.data);
              }
              if (this.inline) {
                this.existing_speakers = [...(this.existing_speakers || []), ...(response.data || [])];
                this.clear_form();
                this.add_speaker_button();
                return;
              }
              $("#add_speakers_modal").modal("hide");
              this.clear_form();
            });
          }
        },
        error: (response) => {
          Swal.close();
          const response_data = response.responseJSON || {};
          Swal.fire({
            icon: "error",
            title: "Error",
            text: response_data.message || "An error occurred while adding the Speakers, please try again.",
            showConfirmButton: false,
            timer: 3000,
            position: 'bottom-end',
            toast: true
          });
        },
      });
    },
    delete_speaker(speaker_id) {
      Swal.fire({
        title: "Are you sure?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        position: 'bottom-end',
        toast: true
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            type: "DELETE",
            url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/delete_event_speaker/`,
            data: JSON.stringify({ speaker_id }),
            headers: { Authorization: `Token ${this.getToken()}`, "Content-Type": "application/json" },
            success: (response) => {
              if (response.status === "success") {
                Swal.fire({
                  title: "Deleted!",
                  text: "The event has been deleted.",
                  icon: "success",
                  showConfirmButton: false,
                  timer: 1000,
                  position: 'bottom-end',
                  toast: true
                }).then(() => {
                  if (this.selected_event_agenda?.speakers) {
                    this.selected_event_agenda.speakers = this.selected_event_agenda.speakers.filter(s => s.id !== speaker_id);
                  }
                  if (this.current_event?.speakers) {
                    this.current_event.speakers = this.current_event.speakers.filter(s => s.id !== speaker_id);
                  }
                  if (this.inline) {
                    this.speakers = (this.speakers || []).filter((s) => Number(s?.id) !== Number(speaker_id));
                    if (!this.speakers.length) this.speakers = [this.new_speaker()];
                  }
                  Swal.close();
                });
              }
            },
            error: (response) => {
              Swal.fire({ title: "Error!", text: response.responseJSON.message, icon: "error" ,
              position: 'bottom-end',
              showConfirmButton: false,
              timer: 3000,
              toast: true
              });
            }
          });
        }
      });
    },
    edit_speaker(speaker) {
      this.selected_event_speaker = speaker;
      $("#edit_speaker_modal").modal("show");
      $("#event_speakers_modal").modal("hide");
    },
    edit_speaker_from_add(speaker) {
      this.selected_event_speaker = speaker;
      this.editPhotoPreviewUrl = null;
      this.editPhotoFile = null;
      $("#edit_speaker_modal").modal("show");
    },
    add_edit_social_link() {
      if (!this.selected_event_speaker.social_urls) {
        this.selected_event_speaker.social_urls = [];
      }
      this.selected_event_speaker.social_urls.push({
        social_url: "",
        social_type: { name: "linkedin" }
      });
    },
    remove_edit_social_link(index) {
      this.selected_event_speaker.social_urls.splice(index, 1);
    },
    handle_edit_photo_upload(event) {
      const file = event.target.files[0];
      if (file) {
        this.editPhotoFile = file;
        this.editPhotoPreviewUrl = URL.createObjectURL(file);
      }
    },
    validate_update_speakers() {
      this.speakers_errors = {};
      let isValid = true;
      if (!this.selected_event_speaker.first_name || this.selected_event_speaker.first_name.trim() === "") {
        this.speakers_errors["speaker_first_name"] = "First name is required.";
        isValid = false;
      }
      if (!this.selected_event_speaker.last_name || this.selected_event_speaker.last_name.trim() === "") {
        this.speakers_errors["speaker_last_name"] = "Last name is required.";
        isValid = false;
      }
      return isValid;
    },
    async update_speaker() {
      if (this.validate_update_speakers()) {
        Swal.fire({
          title: "Updating...",
          text: "Please wait while we save your changes.",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        const formData = new FormData();
        formData.append("speaker_id", this.selected_event_speaker.id);
        formData.append("first_name", this.selected_event_speaker.first_name);
        formData.append("last_name", this.selected_event_speaker.last_name);
        formData.append("bio", this.selected_event_speaker.bio || "");
        const mappedSocialUrls = this.selected_event_speaker.social_urls.map(link => ({
          social_type: link.social_type.name,
          social_url: link.social_url
        }));
        formData.append("social_urls", JSON.stringify(mappedSocialUrls));
        if (this.editPhotoFile instanceof File) {
          formData.append("speaker_file", this.editPhotoFile);
        }
        $.ajax({
          type: "POST",
          url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/update_event_speaker/`,
          data: formData,
          processData: false,
          contentType: false,
          headers: { Authorization: `Token ${this.getToken()}` },
          success: (response) => {
            if (response.status === "success") {
              Swal.fire({
                icon: "success",
                title: "Speaker Updated",
                text: response.message,
                showConfirmButton: false,
                timer: 2000,
                position: 'bottom-end',
                toast: true
              }).then(() => {
                $("#edit_speaker_modal").modal("hide");
                $("#event_speakers_modal").modal("show");
                if (this.selected_event_agenda?.speakers) {
                  const idx = this.selected_event_agenda.speakers.findIndex(s => s.id === this.selected_event_speaker.id);
                  if (idx !== -1) this.selected_event_agenda.speakers.splice(idx, 1, response.data);
                }
                if (this.current_event?.speakers) {
                  const idx = this.current_event.speakers.findIndex(s => s.id === this.selected_event_speaker.id);
                  if (idx !== -1) this.current_event.speakers.splice(idx, 1, response.data);
                }
                this.selected_event_speaker = null;
                this.editPhotoFile = null;
              });
            }
          },
          error: (response) => {
            Swal.close();
            const response_data = response.responseJSON || {};
            Swal.fire({
              icon: "error",
              title: "Error",
              text: response_data.message || "An error occurred while updating the Speaker.",
              showConfirmButton: false,
              timer: 3000,
              position: 'bottom-end',
              toast: true
            });
          },
        });
      }
    },
    fetch_social_types() {
      $.ajax({
        type: "GET",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/get_social_types/`,
        headers: { Authorization: `Token ${this.getToken()}` },
        success: (response) => {
          if (response.status === "success") {
            this.social_platforms = response.data.map(type => ({
              id: type.id,
              value: type.name,
              label: type.name.charAt(0).toUpperCase() + type.name.slice(1)
            }));
          }
        },
        error: (error) => {
          console.error("Error fetching social types:", error);
        }
      });
    }
  }
};
